import { render } from "./level.vue?vue&type=template&id=28d7d0b8&scoped=true&ts=true"
import script from "./level.vue?vue&type=script&lang=ts"
export * from "./level.vue?vue&type=script&lang=ts"

import "./level.vue?vue&type=style&index=0&id=28d7d0b8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d7d0b8"]])

export default __exports__